import React from 'react';
import { FiHeadphones, FiBriefcase, FiSettings, FiCode, FiBookOpen, FiArrowUpCircle, FiShare2, FiCheck } from 'react-icons/fi';

const services = [
  {
    title: 'Odoo Consulting',
    icon: FiBriefcase,
    features: [
      'Process Mapping & Gap Analysis',
      'Best-Practice Implementation Roadmap',
      'Change Management Planning',
      'User Training Roadmap',
      'Odoo Licensing & Hosting Consultation',
    ],
  },
  {
    title: 'Odoo Customization',
    icon: FiCode,
    features: [
      'Custom Module Development',
      'UI/UX Enhancements',
      'Theme Customization',
      'Workflow Automation',
      'Custom Reports & Dashboards',
    ],
  },
  {
    title: 'Odoo Implementation',
    icon: FiSettings,
    features: [
      'Discovery & Requirement Analysis',
      'System Setup & Module Configuration',
      'Data Migration & Cleanup',
      'Module Selection, Customization & Testing',
      'Deployment & Go-Live',
    ],
  },
  {
    title: 'Odoo Training',
    icon: FiBookOpen,
    features: [
      'Role-Based User Training',
      'Train-the-Trainer Sessions',
      'On-Demand Knowledge Base',
      'Hands-On Workshops',
      'Administrator Training',
    ],
  },
  {
    title: 'Odoo Upgrade',
    icon: FiArrowUpCircle,
    features: [
      'Version Upgrades',
      'Switch from Community to Enterprise Edition',
      'Code Refactoring for Upgrade Compatibility',
      'UI/UX Transition Adjustments',
      'Upgrade Feasibility Review',
    ],
  },
  {
    title: 'Odoo Integrations',
    icon: FiShare2,
    features: [
      'Key Marketplace Integrations with Odoo',
      'eCommerce Platform Integrations with Odoo',
      'Shipping & Logistics Integrator Connections',
      'Payment Gateway Integrations',
      'Marketing & CRM Tool Integrations',
    ],
  },
  {
    title: 'Odoo Support & Maintenance',
    icon: FiHeadphones,
    features: [
      'Dedicated Helpdesk',
      'Incident Management & Resolution',
      'Performance Tuning',
      'Security Audits',
      'Regular Updates & Patches',
    ],
  },
];

function ServiceCard({ service, index, featured = false }) {
  const Icon = service.icon;

  return (
    <article
      className={`group relative overflow-hidden rounded-2xl border p-6 sm:p-8 motion-safe:transition-all motion-safe:duration-300 motion-safe:hover:-translate-y-1 hover:shadow-lg ${featured ? 'lg:grid lg:grid-cols-[1fr_2fr] lg:items-center lg:gap-12' : 'h-full'}`}
      style={{ backgroundColor: featured ? '#F5F0F4' : '#FFFFFF', borderColor: featured ? '#E7DAE3' : '#E8E8ED' }}
    >
      <div>
        <div className="mb-6 flex items-center justify-between">
          <div
            className="flex h-12 w-12 items-center justify-center rounded-xl motion-safe:transition-transform motion-safe:duration-300 motion-safe:group-hover:scale-110"
            style={{ backgroundColor: '#714B67', color: '#FFFFFF' }}
          >
            <Icon className="h-6 w-6" strokeWidth={1.6} aria-hidden="true" />
          </div>
          {/* {!featured && (
            <span className="text-xs font-medium tracking-widest" style={{ color: '#9A9199' }} aria-hidden="true">
              {String(index + 1).padStart(2, '0')}
            </span>
          )} */}
        </div>
        <h3 className="text-lg font-bold leading-snug tracking-tight sm:text-xl" style={{ color: '#111111' }}>
          {service.title}
        </h3>
        {featured && (
          <p className="mb-0 mt-3 text-sm font-medium leading-relaxed" style={{ color: '#30303A' }}>
            Ongoing care for a reliable, secure Odoo environment.
          </p>
        )}
      </div>
      <ul
        className={`mb-0 mt-6 list-none p-0 ${featured ? 'grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2 lg:mt-0' : 'space-y-3 border-t pt-6'}`}
        style={{ borderColor: '#F0EDF0' }}
      >
        {service.features.map((feature) => (
          <li key={feature} className="flex items-start gap-3">
            <FiCheck className="mt-1 h-4 w-4 shrink-0" style={{ color: '#714B67' }} aria-hidden="true" />
            <span className="text-sm font-medium leading-relaxed" style={{ color: '#262630' }}>
              {feature}
            </span>
          </li>
        ))}
      </ul>
    </article>
  );
}

export default function OdooBenefitsSection() {
  return (
    <section
      className="px-4 py-16 sm:px-6 sm:py-20 lg:px-8"
      style={{ backgroundColor: '#FFFFFF' }}
      aria-labelledby="odoo-services-heading"
    >
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 flex flex-col gap-5 sm:mb-12 lg:flex-row lg:items-end lg:justify-between lg:gap-16">
          <div>
            <div className="mb-4 flex items-center gap-3" style={{ color: '#714B67' }}>
              <span className="h-px w-8" style={{ backgroundColor: '#714B67' }} aria-hidden="true" />
              <span className="text-xs font-semibold uppercase tracking-[0.18em]">Odoo expertise</span>
            </div>
            <h2 id="odoo-services-heading" className="m-0 text-3xl font-bold leading-tight tracking-tight sm:text-4xl" style={{ color: '#111111' }}>
              Our Odoo Services
            </h2>
          </div>
          <p className="m-0 max-w-lg text-sm font-medium leading-relaxed sm:text-base" style={{ color: '#30303A' }}>
            The right guidance, a smooth implementation, and lasting support.
            Everything you need to make Odoo work for your business.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {services.slice(0, -1).map((service, index) => (
            <ServiceCard key={service.title} service={service} index={index} />
          ))}
        </div>
        {/* <div className="mt-5 lg:mt-6">
          <ServiceCard service={services[services.length - 1]} featured />
        </div> */}
      </div>
    </section>
  );
}
